import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sort-indicator',
    templateUrl: './sort-indicator.component.html',
    standalone: false
})
export class SortIndicatorComponent {
  @Input()  sort: string = '';
  @Input()  property: string = '';
  get isAsc(): boolean { return this.sort==this.property}
  get isDesc(): boolean { return this.sort==`-${this.property}`}
}
